export { SchoolSettingsPage } from './SchoolSettingsPage'
